import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Unpacking The Blockchain Revolution | Amalia Grochal</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>To kick off the new season of Technology for a Change, we invited Amalia Irena Grochal, one of the pioneers in fintech in the Middle East and founder of Mirai Dao - a crypto investment and advisory firm. Amalia delved into the blockchain revolution on our podcast, having an insightful discussion about decentralized finance and Web3, among others, with our host Hady Sheikh.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;